import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { AgentGallery } from './components/AgentGallery';
import { Features } from './components/Features';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
// Add smooth scrolling behavior
import './smoothScroll.css';
export function App() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <AgentGallery data-id="element-5" />
        <Features data-id="element-6" />
        <CTA data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}